import * as AppConstants from 'app/AppConstants';
import {concat, difference} from 'utilities/Set';

const initialState = () => ({
  isLoadingUserById: new Set(),
  isLoadingUserDetailsById: new Set(),
  details: {},
  users: {},
  byChannelId: {},
  cardStatisticsById: {},
  allUserIds: new Set(),
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.USER__LOAD_USERS_DETAILS_STARTED: {
      const isLoadingUserDetailsById = concat(
        state.isLoadingUserDetailsById,
        action.payload.ids
      );
      return {
        ...state,
        isLoadingUserDetailsById,
      };
    }
    case AppConstants.USER__LOAD_USERS_DETAILS_FINISHED: {
      const details = action.payload.reduce(
        (memo, user) => {
          memo[user.id] = user;
          return memo;
        },
        {...state.details}
      );

      const isLoadingUserDetailsById = difference(
        state.isLoadingUserDetailsById,
        action.payload.map(user => user.id)
      );

      return {
        ...state,
        details,
        isLoadingUserDetailsById,
      };
    }
    case AppConstants.USER__LOAD_USERS_DETAILS_FAILED: {
      const isLoadingUserDetailsById = difference(
        state.isLoadingUserDetailsById,
        action.payload.ids
      );
      return {
        ...state,
        isLoadingUserDetailsById,
      };
    }
    case AppConstants.USER__LOAD_USERS_STARTED: {
      const isLoadingUserById = concat(
        state.isLoadingUserById,
        action.payload.ids
      );
      return {
        ...state,
        isLoadingUserById,
      };
    }
    case AppConstants.USER__LOAD_ALL_USERS_FINISHED: {
      const payloadUsers = action.payload.users;

      const users = payloadUsers.reduce(
        (memo, user) => {
          memo[user.id] = user;
          return memo;
        },
        {...state.users}
      );

      const userIds = payloadUsers.map(u => u.id);

      return {
        ...state,
        users,
        allUserIds: concat(state.allUserIds, userIds),
      };
    }

    case AppConstants.USER__LOAD_USERS_FINISHED: {
      const users = action.payload.reduce(
        (memo, user) => {
          memo[user.id] = user;
          return memo;
        },
        {...state.users}
      );

      const isLoadingUserById = difference(
        state.isLoadingUserById,
        action.payload.map(user => user.id)
      );

      return {
        ...state,
        users,
        isLoadingUserById,
      };
    }

    case AppConstants.USER__LOAD_USERS_FAILED: {
      const isLoadingUserById = difference(
        state.isLoadingUserById,
        action.payload.ids
      );
      return {
        ...state,
        isLoadingUserById,
      };
    }
    case AppConstants.BUZZ__USER_PERMISSIONS_LOADED: {
      const channelId = action.payload.channelId;
      const userIds = action.payload.userPermissions.reduce(
        (memo, permission) => {
          return memo.add(permission.id);
        },
        new Set(state.byChannelId[channelId])
      );
      return {
        ...state,
        byChannelId: {
          ...state.byChannelId,
          [channelId]: userIds,
        },
      };
    }
    case AppConstants.BUZZ__PINNED_USERS_LOADED: {
      const channelId = action.payload.channelId;
      const userIds = action.payload.pinnedUserIds.reduce((memo, id) => {
        return memo.add(id);
      }, new Set(state.byChannelId[channelId]));
      return {
        ...state,
        byChannelId: {
          ...state.byChannelId,
          [channelId]: userIds,
        },
      };
    }

    case AppConstants.USER__CARD_STATISTICS_LOADED: {
      return {
        ...state,
        cardStatisticsById: {
          [action.payload.userId]: action.payload.statistics,
        },
      };
    }

    case AppConstants.PEOPLE__PROFILE_EDIT_FINISHED: {
      const {userId, profile} = action.payload;
      return {
        ...state,
        users: {
          [userId]: {
            ...state.users.userId,
            avatarKey: profile.profileImage,
            displayName: profile.displayName,
            detail: {
              email: profile.emailAddress,
              title: profile.userTitle,
              location: profile.employeeLocation,
              phoneNumber: profile.phoneNumber,
              deskPhoneNumber: profile.deskPhoneNumber,
            },
          },
        },
      };
    }

    case AppConstants.PEOPLE__LOADED_ALL_PEOPLE:
      console.error('Implement user caching from all people loading...');
      return state;
    default:
      return state;
  }
};
